import _ from 'lodash';
import Vue from 'vue';
import { HTTP } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

export default {
  actions: {
    async [actions.DO_GET_ACCOUNT]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.get(`/accounts/${id}`, { params });
      commit(mutations.SET_ACCOUNT, data.data.accounts[0]);
      return data;
    },
    async [actions.DO_GET_ACCOUNTS]({ commit }, params) {
      const { data } = await HTTP.get('/self/accounts', { params });
      const accounts = data.data.accounts;
      commit(mutations.SET_ACCOUNTS, accounts);
      return data;
    },
    async [actions.DO_UPDATE_ACCOUNT]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.patch(`/accounts/${id}`, params);
      commit(mutations.SET_ACCOUNT, data.data.accounts[0]);
      return data;
    },
  },
  getters: {
    [getters.GET_ACCOUNT]: state => state.account,
  },
  mutations: {
    [mutations.ADD_TO_GALLERY_FOR_ACCOUNT](state, payload) {
      state.account._embedded[payload.key].push(payload.val);
    },
    [mutations.REMOVE_FROM_GALLERY_FOR_ACCOUNT](state, payload) {
      state.account._embedded[payload.key].splice(payload.index, 1);
    },
    [mutations.SET_ACCOUNT](state, account) {
      const key = btoa(`${account.api_key}:${account.api_secret}`);
      const headers = _.cloneDeep(HTTP.defaults.headers);
      headers.common.Account = key;
      HTTP.defaults.headers = headers;
      state.account = account;
    },
    [mutations.SET_ACCOUNT_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.account;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutations.SET_ACCOUNTS](state, accounts) {
      state.accounts = accounts;
    },
    [mutations.SORT_GALLERY_FOR_ACCOUNT](state, payload) {
      const gallery = state.account._embedded[payload.key];
      const element = gallery[payload.from];
      gallery.splice(payload.from, 1);
      gallery.splice(payload.to, 0, element);
    },
  },
  state: {
    account: {},
    accounts: [],
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/account.js